(function ($, njm) {
    'use strict';

    njm.views.blockQuote = Backbone.View.extend({

        events: {
           
        },

        initialize: function () {
			
			this.blockCode = "zb";
			
            this.defaultMsgEl = this.$('[block-code=zb]');
			
        	this.qStrParams = new URLSearchParams(window.location.search);
			
			if ( this.qStrParams.has('block-code') ) {
                this.blockCode = this.qStrParams.get('block-code');
            }
            
            this.showBlockMessage(this.blockCode);
        },

        showBlockMessage: function (blockCode) {
			var blockEl = this.$('[block-code=' + blockCode + ']');
			
			if ( blockEl.length > 0 ) {
				
				if (blockCode != "zb"){
					this.defaultMsgEl.hide();
				}
				
				blockEl.show();
				
			} else {
				
				console.log("Block Code missing");
				
				if (this.defaultMsgEl.length === 1) {
					
					this.defaultMsgEl.show();
					console.log("Default block message shown");
					
				}
				
			}

        }
    })
})(jQuery, njm);
